'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInput = exports.RadioGroup = undefined;

var _templateObject = _taggedTemplateLiteral([''], ['']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 4px 0;\n'], ['\n  padding: 4px 0;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RadioGroup = exports.RadioGroup = _styledComponents2.default.div(_templateObject);

RadioGroup.displayName = 'RadioGroup';
var RadioInput = exports.RadioInput = _styledComponents2.default.div(_templateObject2);
RadioInput.displayName = 'RadioInput';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-radio-group/styles.js
// module id = 3028
// module chunks = 4